<template>
  <div>
    <div
      v-for="(neighbourhood, i) in neighbourhoods"
      :key="neighbourhood.name"
    >
      <div
        v-if="width > 1024"
        class="text-left grid grid-cols-3 my-6"
      >
        <div class="mr-24">
          <h3 class="font-title font-bold text-2xl leading-7 text-neutral-900">
            {{ neighbourhood.name }}
          </h3>
          <span
            v-if="neighbourhood.description"
            class="mt-2"
            :class="{
              'text-sm text-neutral-700': isRebranded,
              'vetster-prose': !isRebranded,
            }"
          >
            {{ neighbourhood.description }}
          </span>
        </div>
        <div class="col-span-2 grid grid-cols-2 gap-x-24 gap-y-6">
          <div
            v-for="(activity, index) in neighbourhood.activities"
            :key="neighbourhood.name + activity.name + index"
          >
            <a
              :href="activity.link"
              :class="{
                'font-semibold text-sm text-ocean-900 mb-2 hover:underline': isRebranded,
                'vetster-nav-link font-bold text-indigo-800 mb-2': !isRebranded,
              }"
            >
              {{ activity.name }}
            </a>
            <div class="text-sm text-neutral-500">
              {{ activity.description }}
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <vetster-accordion :default-open="true">
          <template #title>
            <h2 class="font-normal font-title text-xl leading-6">
              <span class="font-bold text-neutral-900">{{ neighbourhood.name }}</span>
            </h2>
          </template>
          <template #content>
            <div
              v-if="neighbourhood.description"
              class="text-sm text-neutral-700 text-left my-4"
            >
              {{ neighbourhood.description }}
            </div>
            <div
              v-for="(activity, index) in neighbourhood.activities"
              :key="neighbourhood.name + activity.name + index"
              class="text-left"
              :class="{
                'mb-4': index !== neighbourhood.activities.length - 1,
                'mt-6': index === 0 && !neighbourhood.description,
              }"
            >
              <a
                :href="activity.link"
                class="font-semibold text-ocean-900 text-sm"
              >
                {{ activity.name }}
              </a>
              <div class="text-sm text-neutral-500">
                {{ activity.description }}
              </div>
            </div>
          </template>
        </vetster-accordion>
      </div>
      <hr v-if="i !== neighbourhoods.length - 1" />
    </div>
  </div>
</template>

<script>
import VetsterAccordion from '@/components//VetsterAccordion';

export default {
  name: 'VetsterNeighborhoodTile',

  components: { VetsterAccordion },

  props: {
    isRebranded: {
      type: Boolean,
      default: false,
    },
    neighbourhoods: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      width: 0,
    };
  },

  created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },

  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },

  methods: {
    handleResize() {
      this.width = window.innerWidth;
    },
  },
};
</script>
